import { render, staticRenderFns } from "./NotAllocated.vue?vue&type=template&id=5cc3084b"
import script from "./NotAllocated.vue?vue&type=script&lang=js"
export * from "./NotAllocated.vue?vue&type=script&lang=js"
import style0 from "./NotAllocated.vue?vue&type=style&index=0&id=5cc3084b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports